import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OpticalDTLanding from "./components/OpticalDTLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OpticalDTLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;